import {type Draft, produce} from 'immer'

import type {LabelsQueryData} from '../types'

type Labels = NonNullable<LabelsQueryData['payload']['data']['repository']['labels']>
type LabelsDraft = Draft<Labels> & {edges: NonNullable<Draft<Labels>['edges']>}

/**
 * Returns an updater for `queryClient.setQueryData<LabelsCacheData>` that lets
 * the caller mutate the `labels` connection directly. Untouched branches of the
 * cache are kept by reference.
 *
 * The recipe is only invoked when the labels connection (and its `edges`) exist.
 */
export function updateLabelsCache(recipe: (labels: LabelsDraft) => void) {
  return (oldData: LabelsQueryData | undefined) => {
    if (!oldData?.payload?.data?.repository?.labels?.edges) return oldData
    return produce(oldData, draft => {
      // Existence verified above; immer's Draft strips the codegen's `readonly` modifiers.
      recipe(draft.payload.data.repository.labels as LabelsDraft)
    })
  }
}
